<template>
     <div>
        <br/>
        <div>
            <base-checkbox class="mb-3" v-model="menus.override_brand_id"><b>Brand</b></base-checkbox>
        </div>
        <div style="padding-left: 35px;">
            <base-input >
                <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="menus.brand_id" :disabled="menus.override_brand_id != true">
                    <a-select-option v-for="option in brands" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
        </div>

        <div style="padding-left: 35px;">
            <base-input label="Sub-brand">
                <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="menus.sub_brand_id" :disabled="menus.override_brand_id != true">
                    <a-select-option v-for="option in subBrands" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
        </div>

     </div>
</template>

<script>

import HTTPRequest from '../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'

var component_x;
export default {
    components: {
        // draggable
    },
    data: function(){
            return {
                menus: {},
                brands: [],
                override_brand_id: false,
                brand_id: null,
                subBrands: [],
                sub_brand_id: null,
                settingCode: null
            }
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
    },
    mounted: async function() {
        // console.log("***************")
        // console.log(this.$attrs.defaultValue)
        component_x = this;
        var brandRequest = await HTTPRequest.getRequest(this.endPoint + '/brands', null);
        this.brands = brandRequest.data
        this.settingCode = this.$attrs.settingCode
    },
    watch: {
        brand_id: async function () {
                var subBrandReq = await HTTPRequest.getRequest(this.endPoint + '/sub_brands?brand_id=' + this.menus.brand_id, null);
                this.subBrands = subBrandReq.data;
        },
        menus: {
            handler: async function() {
                this.brand_id = this.menus.brand_id
                var configValues = {}
                configValues[this.settingCode] = this.menus
                component_x.$emit("changeValue", configValues)
            },
            deep: true
        }  
    },
    methods: {
        
    }
}
</script>

